<template>
  <div id="chart">
    <apexchart
      type="pie"
      :width="width"
      :height="height"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>

<script>
export default {
  name: "PieChart",
  props: {
    series: Array,
    position: String,
    width: Number,
    height: Number,
    labels: Array,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          width: this.width,
          type: 'pie',
        },
        labels: this.labels,
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: this.position,
            }
          }
        }],
        legend: {
          show: true,
          fontSize: '18px',
          fontWeight: 'bold',
          formatter: function (seriesName, opts) {
            const value = opts.w.globals.series[opts.seriesIndex];
            return `${seriesName} (${value})`;
          }
        }
      },
    }
  }
};
</script>

<style lang="scss" scoped></style>
